import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-insurance_map-2018-box');
ai2htmlResize('#g-insurance_map-2021-box');
ai2htmlResize('#g-insurance_map-2024-box');
